<template>
  <div class="baColor">
    <div class="damandList">
      <div class="damandList_box w1200Auto">
        <div class="flex-item-center breadcrumb">
          <span style="font-size: 14px; padding-left: 5px">当前位置：</span>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/supplyHome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item style="cursor: pointer" :to="{ name: 'supplyHome' }"
              >供需对接</el-breadcrumb-item
            >
            <el-breadcrumb-item style="color: #009999"
              >服务商列表</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
        <h1 class="title">服务商列表</h1>
        <div class="searchContainer">
          <!-- 分类 -->
          <div class="print_screen_box flex" style="position: relative">
            <div style="width: 100%; color: #6e6e6e">
              <!-- 所属地区： -->
              <div style="display: flex">
                <p class="print_title">服务分类：</p>
                <div class="print_screen_boxP" style="margin-bottom: 6px">
                  <p
                    v-for="(items, index) in oneServiceList"
                    :key="index"
                    :class="printScreenTwoIndex == index ? 'screen_text' : ''"
                    @click="changeScreenTwo(index, items)"
                    style="cursor: pointer"
                  >
                    {{ items.cdLabel }}
                  </p>
                </div>
              </div>
              <!-- 三级分类 -->
              <div
                class="flex"
                style="
                  padding: 15px 15px 5px;
                  background: #f5f7fa;
                  color: #6e6e6e;
                  margin-left: 93px;
                  display: flex;
                  flex-wrap: wrap;
                "
                v-show="classShow"
              >
                <p
                  v-for="(items, index) in twoServiceList"
                  :key="index"
                  :class="printScreenThreeIndex == index ? 'materDetailsT' : ''"
                  @click="changeScreenThree(index, items)"
                  style="cursor: pointer"
                >
                  {{ items.cdLabel }}
                </p>
              </div>
              <!-- 需求分类： -->
<!--              <div style="display: flex; margin-top: 15px">
                <p class="print_title">所属地区：</p>
                <div class="print_screen_boxP">
                  <p
                    v-for="(items, index) in firstList"
                    :key="index"
                    @click="changeScreen(index, items)"
                    :class="printScreenIndex == index ? 'screen_text' : ''"
                  >
                    {{ items.name }}
                  </p>
                </div>
              </div>-->
            </div>
          </div>
          <!-- 搜索 -->
          <div class="flex searchContainerone">
            <p class="print_title">关键词：</p>
            <el-input
              placeholder="请输入关键词"
              v-model="name"
              class="input-with-select"
              clearable
              prefix-icon="el-icon-search"
            >
            </el-input>
            <el-button type="primary" @click="handleCurrentChange()">
              搜索
            </el-button>
            <p class="quality_box">
              共
              <span>{{totalAll}}</span>
              家
            </p>
          </div>
        </div>
        <!-- 列表 -->
        <qualityServiceProviderMesg @changeList="handleCurrentChange" ref="qualityListInfoRef" @onTotal="onTotal"></qualityServiceProviderMesg>
      </div>
    </div>
  </div>
</template>

<script>
import qualityServiceProviderMesg from "./qualityServiceProviderMesg";
import {ajaxFindServiceAbility, getIndexDictionaryData} from "../../../../utils/interface";
import { nextTick } from 'vue';
export default {
  components: {
    qualityServiceProviderMesg,
  },
  data() {
    return {
      totalAll: 0,
      searchInputValue: "",
      printScreenIndex: "0",
      firstList: [
        {
          name: "全部",
        },
        {
          name: "采购需求",
        },
        {
          name: "服务需求",
        },
      ],
      printScreenTwoIndex: "0",
      oneServiceList: [],
      printScreenThreeIndex: "0",
      twoServiceList: [],
      classShow: false,
      options: [
        {
          value: "222",
          label: "全部",
        },
      ],
      checked: false,
      sortList: [
        {
          name: "发布时间",
          className: "",
          iconsColorShow: "",
        },
        {
          name: "好评",
          className: "",
          iconsColorShow: "",
        },
        {
          name: "服务价格",
          className: "",
          iconsColorShow: "",
        },
      ],
      classifyOne:"",
      classifyTwo:"",
      name:'',
    };
  },
  created() {
    this.initDitc();
    nextTick(() => {
      this.handleCurrentChange();
    });
  },
  methods: {
    onTotal(nums) {
      this.totalAll = nums
    },
    initDitc(){
      this.serviceAbilityInfo("1");
    },
    changeScreen(index, item) {
      this.printScreenIndex = index;
      this.handleCurrentChange();
    },
    serviceAbilityInfo(rank,cdClass){
      if(rank=="1"){
        ajaxFindServiceAbility({cdRank:rank}).then((res)=>{
          this.oneServiceList = res.tasks;
          this.oneServiceList.unshift({
            cdClass: "",
            cdId: "",
            cdLabel: "全部"
          })
        });
      }else if(rank=="2"){
        ajaxFindServiceAbility({cdRank:rank,cdClass:cdClass}).then((res)=>{
          this.twoServiceList = res.tasks;
          if(res.tasks && cdClass){
            this.classShow = true;
          }else {
            this.classShow = false;
          }
        });
      }
    },
    changeScreenTwo(index, item) {
      this.printScreenTwoIndex = index;
      this.classifyOne = item.cdClass;
      this.printScreenThreeIndex = null;
      this.classifyTwo = ""
      this.serviceAbilityInfo("2",item.cdClass)
      this.handleCurrentChange();
    },
    changeScreenThree(index, item) {
      this.classifyTwo = item.cdClass;
      this.printScreenThreeIndex = index;
      this.handleCurrentChange();
    },
    handleCurrentChange(){
      let param={
        name:this.name,
        classifyOne:this.classifyOne,
        classifyTwo:this.classifyTwo,
      };
      this.$refs.qualityListInfoRef.init(param);
    }
  },
};
</script>

    <style lang="less" scoped>
@import "../../style/index.less";
.damandList {
  background: #f5f7fa;
}
.damandList_box {
  padding: 20px;
  .title {
    font-size: 28px;
    color: #1d1d1d;
    margin: 20px 0 30px;
  }
}
.searchContainer {
  background: #fff;
  padding: 20px 30px;
  padding-top: 26px;
  .searchContainerone {
    margin-top: 15px;
    display: flex;
    align-items: center;
    .searchContainerButton {
      color: #009999;
      margin-left: 60px;
      border: 1px solid #009999;
      background: #fff;
      font-size: 14px;
    }
    button {
      width: 90px;
      border-radius: 8px;
    }
  }
  /deep/.el-input {
    width: 500px;
    margin-right: 10px;
  }
  /deep/ .input-with-select .el-input__inner {
    background: #fdfdfd;
    border: 1px solid #cecece;
    height: 40px;
    border-radius: 8px;
    line-height: 40px;
    width: 500px;
  }

  ul {
    display: flex;
    align-items: center;
    width: 812px;
    padding-left: 3px;
    margin: 0 auto;
    margin-bottom: 15px;
    img {
      width: 20px;
    }
    li {
      font-size: 12px;
      margin-top: 10px;
      padding: 0 15px;

      &.textLi {
        cursor: pointer;

        &:hover {
          color: #009999;
        }
      }
    }
  }
}
.print_title {
  flex-shrink: 0;
  padding-right: 19px;
  padding-left: 0px;
  color: #000;
  font-weight: 500;
  font-size: 14px;
  width: 80px;
  text-align: right;
}
.print_screen_box {
  background: #fff;
  padding: 0 15px 0 0;
  box-sizing: border-box;

  .print_title {
    flex-shrink: 0;
    padding-right: 41px;
    padding-left: 0px;
    color: #000;
    font-weight: 500;
  }

  .print_screen_boxP {
    display: flex;
    flex-wrap: wrap;
    margin-left: -29px;
    p {
      cursor: pointer;
    }

    .screen_text {
      color: #009999;
      border-radius: 5px;
      margin-bottom: 10px;
      padding: 3px 15px;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .screen_text {
    color: #009999;
    cursor: pointer;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 3px 15px;
    font-size: 14px;
  }

  p {
    margin-bottom: 10px;
    margin-right: 0px;
    padding: 3px 14px;
    font-size: 14px;
  }

  .materDetailsT {
    // background: #009999;
    color: #009999;
    border-radius: 5px;
    padding: 3px 15px;
    margin-bottom: 10px;
  }
}
.quality_box {
    font-size: 14px;
    margin-left: 30px;
    color: #909090;
    span {
        font-size: 20px;
        color: #009999;
        font-weight: bold;
        margin: 0 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/list/qualityServiceProviderList.vue